<template>
  <div class="author">
      <h2>Author id: {{ $route.params.id }}</h2>

      <h4> Author name: {{ author.FirstName}} </h4>
    </div>
</template>
<script>

      import * as API from './../../api';

    //const CreateModal = () => import('./CreateDialog');     <CreateModal @create-modal-visibility="changeModalVisibility()"  v-if="createVegetableDialog" :create-vegetable-dialog="createVegetableDialog"></CreateModal>

    export default {
        name: "AuthorDetail",
        methods: {
            getAuthor() {
               this.$api.get(API.endpoints.authors + '/' + this.$route.params.id)
                    .then(response => {
                        this.author = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            title: "Error",
                            message: error,
                            type: 'danger'
                        });
                    });
            },
        },
        data() {
            return {
                author: [ ],
               
            }
        },
        mounted() {
            this.getAuthor();
        },

    }
</script>